module.exports = __webpack_public_path__ + "location.png?a40a22a929f770daeed8c1b42645d5b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/location.png
// module id = 243
// module chunks = 1 2 5 7